<div class="av-skeleton" *ngIf="loading">
  <p-skeleton height="7rem"></p-skeleton>
</div>

<ng-container *ngIf="!loading">
  <!--
    Las dos lentes, lado a lado y con nombre propio. En la hoja de Contabilidad son una sola cifra;
    separarlas ES el arreglo, así que la etiqueta de cada una explica qué mide y contra qué.
  -->
  <div class="av-lenses" *ngIf="summary">
    <div class="av-lens" [ngClass]="clase(exigible)">
      <div class="av-lens-head">
        <span class="av-lens-name">Exigible</span>
        <span class="av-lens-pct">{{ pct(exigible?.rate) }}</span>
      </div>
      <div class="av-bar" *ngIf="exigible?.rate != null">
        <!-- La barra se topa en 100 % aunque la tasa la pase: una barra desbordada no comunica nada. -->
        <span [style.width.%]="(exigible?.rate || 0) * 100 > 100 ? 100 : (exigible?.rate || 0) * 100"></span>
      </div>
      <div class="av-lens-foot">
        <span
          >{{ exigible?.collected | currency: 'MXN' : 'symbol-narrow' : '1.0-0' }} de
          {{ exigible?.base | currency: 'MXN' : 'symbol-narrow' : '1.0-0' }} vencido</span
        >
        <span class="av-gap">{{ brecha(exigible) }}</span>
      </div>
      <p class="av-lens-note">
        Todo el dinero que entró en el mes contra lo que ya venció. <b>Puede pasar del 100 %</b> cuando se cobra cartera de meses
        anteriores.
      </p>
    </div>

    <div class="av-lens" [ngClass]="clase(facturada)">
      <div class="av-lens-head">
        <span class="av-lens-name">Facturada</span>
        <span class="av-lens-pct">{{ pct(facturada?.rate) }}</span>
      </div>
      <div class="av-bar" *ngIf="facturada?.rate != null">
        <span [style.width.%]="(facturada?.rate || 0) * 100"></span>
      </div>
      <div class="av-lens-foot">
        <span
          >{{ facturada?.collected | currency: 'MXN' : 'symbol-narrow' : '1.0-0' }} de
          {{ facturada?.base | currency: 'MXN' : 'symbol-narrow' : '1.0-0' }} facturado</span
        >
        <span class="av-gap">{{ brecha(facturada) }}</span>
      </div>
      <p class="av-lens-note">
        Lo cobrado de lo facturado. Las dos cifras salen del mismo conjunto de facturas, así que esta lente nunca pasa del 100 %.
      </p>
    </div>
  </div>

  <!-- Lo que ya venció al día de corte, que es el denominador honesto a mitad de mes. -->
  <div class="av-due" *ngIf="summary">
    <span
      ><b>{{ summary.dueSoFar?.count || 0 }}</b> {{ summary.dueSoFar?.count === 1 ? 'letra ha vencido' : 'letras han vencido' }} al día de
      hoy, por
      <b>{{ (summary.dueSoFar?.amount || 0) + (summary.dueSoFar?.mora || 0) | currency: 'MXN' : 'symbol-narrow' : '1.2-2' }}</b></span
    >
    <span class="av-due-sep">·</span>
    <span
      >el mes entero suma <b>{{ summary.expected.amount | currency: 'MXN' : 'symbol-narrow' : '1.2-2' }}</b></span
    >
    <span class="av-due-off" *ngIf="!summary.moraEnabled">la mora está apagada: no suma al exigible</span>
  </div>
</ng-container>

<!-- ── La serie ─────────────────────────────────────────────────────────────────────────────── -->
<div class="av-serie">
  <div class="av-serie-head">
    <h3 class="av-h3">Los últimos doce meses</h3>
    <!-- Las dos hojas de Contabilidad: el Avance por bloques de mes y el Dashboard ejecutivo. -->
    <div class="av-export" *ngIf="summary">
      <button
        pButton
        type="button"
        class="p-button-sm p-button-outlined"
        icon="fa-solid fa-file-excel"
        label="Avance"
        pTooltip="AVANCE COBRANZA: un bloque por mes de enero a hoy, como la hoja de Contabilidad"
        tooltipPosition="left"
        [loading]="exportando === 'avance'"
        [disabled]="!!exportando"
        (click)="exportar('avance')"
      ></button>
      <button
        pButton
        type="button"
        class="p-button-sm p-button-outlined"
        icon="fa-solid fa-gauge-high"
        label="Dashboard"
        pTooltip="DASHBOARD COBRANZA: indicadores, semáforo contra la meta e histórico"
        tooltipPosition="left"
        [loading]="exportando === 'dashboard'"
        [disabled]="!!exportando"
        (click)="exportar('dashboard')"
      ></button>
    </div>
  </div>

  <div class="av-skeleton" *ngIf="loadingSerie">
    <p-skeleton height="12rem"></p-skeleton>
  </div>

  <ng-container *ngIf="!loadingSerie && serie">
    <div class="av-scroll">
      <table class="av-table">
        <thead>
          <tr>
            <th>Mes</th>
            <th class="av-num">Letras del mes</th>
            <th class="av-num">Entró</th>
            <!--
              Qué base usa esta columna, dicho en la columna. La lente de arriba mide contra lo que
              ha VENCIDO al día de hoy y esta contra las letras del mes ENTERO: en el mes en curso
              dan números distintos —45× arriba y 8× aquí— y las dos se llamaban «Avance» a secas.
            -->
            <th class="av-num">Avance <span class="av-th-sub">sobre las letras del mes</span></th>
            <th class="av-num">Facturado</th>
            <th class="av-num">Cartera al cierre</th>
          </tr>
        </thead>
        <tbody>
          <tr *ngFor="let p of serie.points">
            <td class="av-mes">{{ p.month }}</td>
            <td class="av-num">{{ p.expectedLetters.amount | currency: 'MXN' : 'symbol-narrow' : '1.0-0' }}</td>
            <td class="av-num">{{ p.received.amount | currency: 'MXN' : 'symbol-narrow' : '1.0-0' }}</td>
            <td class="av-num">
              <span class="av-pill" [ngClass]="clase(p.progress.exigible)">{{ pct(p.progress.exigible.rate) }}</span>
            </td>
            <!-- «No medido» NO es cero: un mes sin una sola factura no facturó cero, no se midió. -->
            <td class="av-num" [class.av-nm]="!p.invoiced">
              {{ p.invoiced ? (p.invoiced.amount | currency: 'MXN' : 'symbol-narrow' : '1.0-0') : 'no medido' }}
            </td>
            <td class="av-num">
              <span *ngIf="p.walletClosing != null" [pTooltip]="'Fotografía congelada del cierre'" tooltipPosition="left">
                {{ p.walletClosing | currency: 'MXN' : 'symbol-narrow' : '1.0-0' }}
                <i class="fa-solid fa-lock av-lock"></i>
              </span>
              <span class="av-nm" *ngIf="p.walletClosing == null">sin cerrar</span>
            </td>
          </tr>
        </tbody>
      </table>
    </div>

    <!--
      Una serie histórica que no declara su base invita a discutir contra ella como si fuera un acta.
      Las salvedades vienen del servidor y se pintan enteras: acortarlas aquí sería volver a esconderlas.
    -->
    <ul class="av-caveats">
      <li *ngFor="let c of serie.caveats">{{ c }}</li>
    </ul>
  </ng-container>
</div>

<!-- ── El Avance de Contabilidad: de dónde sale cada mes y lo capturado de su libro ──────────── -->
<app-avance-capturas [month]="month"></app-avance-capturas>
